'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UniqueIngredientName = function () {
  function UniqueIngredientName($q, UserIngredientsService) {
    'ngInject';

    _classCallCheck(this, UniqueIngredientName);

    Object.assign(this, {
      $q: $q,
      UserIngredientsService: UserIngredientsService
    });

    this.require = 'ngModel';
    this.restrict = 'A';
  }

  _createClass(UniqueIngredientName, [{
    key: 'link',
    value: function link($scope, element, attrs, ctrl) {
      var _this = this;

      var ingredientId = null;

      if (attrs.ingredientId) {
        ingredientId = attrs.ingredientId;
      }

      // Async validator requires resolve or reject to set validity
      ctrl.$asyncValidators.uniqueUserIngredientName = function (ingredientName) {
        var defer = _this.$q.defer();

        _this.UserIngredientsService.isUniqueIngredientName(ingredientName, ingredientId).then(function (r) {
          if (r.data) {
            defer.resolve();
          }

          defer.reject();
        }).catch(function () {
          return defer.reject();
        });

        return defer.promise;
      };
    }
  }], [{
    key: 'directiveFactory',
    value: function directiveFactory($q, UserIngredientsService) {
      'ngInject';

      return new UniqueIngredientName($q, UserIngredientsService);
    }
  }]);

  return UniqueIngredientName;
}();

exports.default = UniqueIngredientName;


// WEBPACK FOOTER //
// ./common/directives/validation/unique-ingredient-name.js